export async function sendEmailMsg(payload) {
  const serverURL = process.env.REACT_APP_API_URL
  const response = await fetch(serverURL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  return response.json();
}
